import { render, staticRenderFns } from "./og-custom-dropdown.vue?vue&type=template&id=5159b0f3&"
import script from "./og-custom-dropdown.vue?vue&type=script&lang=js&"
export * from "./og-custom-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports